import React from 'react';
import { Box, Typography, LinearProgress, Paper } from '@mui/material';

interface SimpleBarChartProps {
  title: string;
  data: Array<{ label: string; value: number; color?: string }>;
  maxValue?: number;
  height?: number;
}

const SimpleBarChart: React.FC<SimpleBarChartProps> = ({ 
  title, 
  data, 
  maxValue, 
  height = 200 
}) => {
  const actualMaxValue = maxValue || Math.max(...data.map(d => d.value), 1);

  return (
    <Paper sx={{ p: 2, height }}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Box sx={{ height: height - 60, display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
        {data.map((item, index) => (
          <Box key={index} sx={{ mb: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
              <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
                {item.label}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 'bold' }}>
                {item.value}
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={(item.value / actualMaxValue) * 100}
              sx={{
                height: 8,
                borderRadius: 4,
                backgroundColor: 'grey.200',
                '& .MuiLinearProgress-bar': {
                  backgroundColor: item.color || 'primary.main',
                  borderRadius: 4,
                }
              }}
            />
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default SimpleBarChart;
